export enum ArticleType {
  CareArticle = 'careArticle',
  LearnLibrary = 'learnLibrary',
  Lesson = 'lesson',
}
